export const compressImageFile = async (
  file,
  {
    maxWidth = 1280,
    maxHeight = 1280,
    quality = 0.8,
    maxSizeMB = 1,
  } = {}
) => {
  if (!file || !file.type || !file.type.startsWith('image/')) {
    return file;
  }

  const loadImage = (fileObj) =>
    new Promise((resolve, reject) => {
      const url = URL.createObjectURL(fileObj);
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(url);
        resolve(img);
      };
      img.onerror = (err) => {
        URL.revokeObjectURL(url);
        reject(err);
      };
      img.src = url;
    });

  const img = await loadImage(file);
  const { width, height } = img;
  const scale = Math.min(1, maxWidth / width, maxHeight / height);
  const targetWidth = Math.max(1, Math.round(width * scale));
  const targetHeight = Math.max(1, Math.round(height * scale));
  const sizeLimit = maxSizeMB * 1024 * 1024;
  const needsResize = scale < 1;
  const needsCompress = needsResize || file.size > sizeLimit;

  if (!needsCompress) {
    return file;
  }

  const canvas = document.createElement('canvas');
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return file;
  }

  ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

  const mimeType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob(
      (result) => {
        if (result) resolve(result);
        else reject(new Error('Failed to compress image.'));
      },
      mimeType,
      mimeType === 'image/jpeg' ? quality : 1
    );
  });

  return new File([blob], file.name, {
    type: mimeType,
    lastModified: file.lastModified,
  });
};
